// @flow

import { p2pLog } from '../logger'
import { getSwarmId, createStreamSwarmIdBuilder } from '../utils'
import { attachP2PDebug } from '../debug'

// eslint-disable-next-line complexity
export const createHlsP2P = async ({ srcUrl, p2pConfig }: { srcUrl: ?string, p2pConfig: ?Object }) => {
  const [{ default: Hls }, { HlsJsP2PEngine }, { computeStreamIdentityHash }] = await Promise.all([
    import('hls.js'),
    // eslint-disable-next-line import/no-unresolved -- exports-only package, resolved by webpack
    import('p2p-media-loader-hlsjs'),
    // eslint-disable-next-line import/no-unresolved -- exports-only package, resolved by webpack
    import('p2p-media-loader-core'),
  ])

  if (!Hls.isSupported()) throw new Error('hls.js not supported')

  const HlsWithP2P = HlsJsP2PEngine.injectMixin(Hls)
  const swarmId = getSwarmId(srcUrl)
  const core = {
    ...p2pConfig,
    ...(swarmId && {
      swarmId,
    }),
    streamSwarmIdBuilder: createStreamSwarmIdBuilder(computeStreamIdentityHash),
  }

  p2pLog('[P2P][hlsjs] effective core config:', core)

  const hls = new HlsWithP2P({ p2p: { core } })

  attachP2PDebug(hls.p2pEngine, null)

  return { hls, Hls }
}
